import React, { Component, Fragment } from 'react'

import { checkValidity, updateObject, extractFormData } from '../../helpers/utils'
import { connect } from 'react-redux'
import Alert from '../../components/Alert/Alert'
import { signIn, forgotPass } from '../../store/actions'
import { withTranslate } from 'react-redux-multilingual'
import ForgetPassModal from '../../components/PageContent/Auth/ForgetPassModal/ForgetPassModal'
import seeKPILogo from '../../assets/final-SEEKPI.png'
import AuthPanelContent from '../../components/PageContent/Auth/AuthPanelContent/AuthPanelContent'

class AuthBox extends Component {
  state = {
    loginForm: {
      login: {
        label: 'Username or Email',
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: 'Username or Email',
          size: 'small'
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      password: {
        label: 'Password',
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password',
          size: 'small'
        },
        value: '',
        validation: {
          required: true,
          minLength: 6
        },
        valid: false,
        touched: false,
        error: null
      },
      language: {
        label: 'Language',
        elementType: 'originalSelect',
        elementConfig: {
          options: [
            { key: 'en', value: 'en', label: 'English' },
            { key: 'th', value: 'th', label: 'Thai' }
          ],
          fullWidth: true
        },
        value: 'en',
        valid: true,
        touched: false,
        error: null
      }
    },
    forget: {
      label: 'Email',
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: 'Email'
      },
      value: '',
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false,
      error: null
    },
    modalOpen: false,
    rememberMeChecked: true,
    forgetIsValid: false
  }

  onInputChangeHandler = (formKey, event) => {
    const formItem = { ...this.state.loginForm[formKey] }
    const inputValue = event.target.value
    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updatedForm = updateObject(this.state.loginForm, { [formKey]: updatedFormItem })

    this.setState({ loginForm: updatedForm })
  }

  onForgetChangeHandler = event => {
    const formItem = this.state.forget
    const inputValue = event.target.value
    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    let formIsValid = isValid
    this.setState({ forget: updatedFormItem, forgetIsValid: formIsValid })
  }

  onRememberCheckChangeHandler = e => {
    this.setState({
      rememberMeChecked: e.target.checked
    })
  }

  onForgetFormSubmitHandler = event => {
    event.preventDefault()

    // TODO: connect to api with redux
    this.props.forgotPass({ email: this.state.forget.value })
    this.setState({ modalOpen: false })
  }

  onLoginFormSubmitHandler = event => {
    event.preventDefault()

    const formData = extractFormData(this.state.loginForm)

    this.props.signIn(formData)
  }

  openForgetModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModalHandler = () => {
    this.setState({
      modalOpen: false
    })
  }

  render() {
    return (
      <Fragment>
        <Alert />
        <ForgetPassModal
          open={this.state.modalOpen}
          onHide={this.closeModalHandler}
          forgetForm={{ forget: this.state.forget }}
          onFormChange={this.onForgetChangeHandler}
          onFormSubmit={this.onForgetFormSubmitHandler}
          translate={this.props.translate}
        />
        <AuthPanelContent
          loginForm={this.state.loginForm}
          inputChanged={this.onInputChangeHandler}
          formSubmitted={this.onLoginFormSubmitHandler}
          forgetClicked={this.openForgetModal}
          logoSrc={seeKPILogo}
          translate={this.props.translate}
        />
      </Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signIn: credentials => dispatch(signIn(credentials)),
    forgotPass: credentials => dispatch(forgotPass(credentials))
  }
}

export default connect(null, mapDispatchToProps)(withTranslate(AuthBox))
